// extracted by mini-css-extract-plugin
export default {"link":"BaseCsvDownloadLink--link--68867f"};